import { render, staticRenderFns } from "./showTopicsArticleLinks.vue?vue&type=template&id=710c9acb&scoped=true&"
import script from "./showTopicsArticleLinks.vue?vue&type=script&lang=js&"
export * from "./showTopicsArticleLinks.vue?vue&type=script&lang=js&"
import style0 from "./showTopicsArticleLinks.vue?vue&type=style&index=0&id=710c9acb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710c9acb",
  null
  
)

export default component.exports